import Table from "../../../component/table/Table";
import { selectError, selectIsLoading, selectTerreni } from "../../../features/terreni/terreniSlice";
import { fetchTerreni } from "../../../features/terreni/terreniThunk";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { CircularProgress, Box } from "@mui/material";
import { fetchCompanies } from "../../../features/company/companyThunk";


const SubTerreni = () => {

  const selectSelectedCompany = useSelector((state) => state.company.selectedCompany);
  const columns = [
    { field: "nome", headerName: "Nome del terreno", width: 140 },
    { field: "superficie_totale", headerName: "Sup. Totale (HA)", width: 140 },
    { field: "superficie_coltivata", headerName: "Sup. coltivata (HA)", width: 140 },
    { field: "altitudine", headerName: "Altitudine (m)", width: 125 },
    { field: "esposizione", headerName: "Esposizione", width: 104 },
    { field: "tipo_suolo", headerName: "Tipo di suolo", width: 105 },
    { field: "irrigazione", headerName: "Irrigazione", width: 104 },
    { field: "sistema_coltivazione", headerName: "Coltivazione", width: 105 },
    { field: "coordinate_gps", headerName: "Coordinate GPS", width: 155 },
    { field: "azioni", headerName: "Azioni", width: 62, sortable: false },
  ];

  useEffect(() => {
    dispatch(fetchCompanies())
  },[])

  const dispatch = useDispatch()
  const terreni = useSelector(selectTerreni) || []
  const terreniLoading = useSelector(selectIsLoading)
  const terreniError = useSelector(selectError)
  useEffect(() => {
    dispatch(fetchTerreni())
  }, [dispatch, selectSelectedCompany])
  const mappedData = terreni.map((item) => ({
    nome: item.nome,
    id: item.id,
    superficie_totale: item.superficie_totale,
    superficie_coltivata: item.superficie_coltivata,
    comune: item.comune,
    provincia: item.provincia,
    regione: item.regione,
    altitudine: item.altitudine,
    esposizione: item.esposizione,
    tipo_suolo: item.tipo_suolo,
    irrigazione: item.irrigazione,
    sistema_coltivazione: item.sistema_coltivazione,
    coordinate_gps: item.coordinate_gps,
    data_acquisizione: item.data_acquisizione,
    note: item.note,
  }))
  return (
    <>
      <div className="pageTemplate">
        {terreniLoading ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
            <CircularProgress color="primary" />
          </Box>
        ) : (
          <Table
            data={mappedData?.length ? mappedData : []}
            columns={columns}
            navData={"terreni"}
            deleteFunctions={"deleteTerreni"} />
        )}


      </div>
    </>
  );
};
export default SubTerreni;